export enum GroupTypes {
  QR = "Con QR",
  GROUP = "Grupo",
}

